import { useQuery } from '@apollo/client';
import { useCallback, useMemo } from 'react';
import { GET_VERTRAGSARTEN_MIT_LOGO, VertragsartenAntwort, VertragsartenStand } from '../api/vertragsartenMitLogo';

export interface VertragsartenNeuladbar {
  stand: VertragsartenStand;
  erneutLaden: () => void;
}

/** Der erneute Abruf ist eine eigene Schnittstelle; der bisherige Hook liefert weiter nur den Stand. */
export default function useVertragsartenNeuladbar(): VertragsartenNeuladbar {
  const { data, previousData, loading, error, refetch } = useQuery<VertragsartenAntwort>(GET_VERTRAGSARTEN_MIT_LOGO, {
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });
  const antwort = data ?? previousData;
  const stand = useMemo<VertragsartenStand>(
    () => ({
      vertragsarten: (antwort?.getAllContractTypes ?? [])
        .map((eintrag) => ({
          id: Number(eintrag.id),
          titel: eintrag.title,
          logoDataUrl: eintrag.logo_data_url ?? null,
        }))
        .sort((a, b) => a.titel.localeCompare(b.titel, 'de')),
      laedt: loading,
      fehler: !loading && !!error,
    }),
    [antwort, loading, error],
  );
  const erneutLaden = useCallback(() => {
    // Der Fehler bleibt im Query-Stand sichtbar, nicht als unbehandelte Promise-Ablehnung.
    refetch().catch(() => undefined);
  }, [refetch]);
  return { stand, erneutLaden };
}
